/**
 * @file Natural alphanumeric sort for lots by auction id then lot number.
 */

const LOCALE_NUMERIC = { numeric: true, sensitivity: 'base' };

/**
 * Compare two lot-like rows: auction id (alphanumeric), then lot number (alphanumeric).
 * Null/undefined auction_id sorts as empty string.
 */
export function compareLotsByAuctionThenLot(a, b) {
  const auctionCmp = String(a?.auction_id ?? '').localeCompare(
    String(b?.auction_id ?? ''),
    undefined,
    LOCALE_NUMERIC
  );
  if (auctionCmp !== 0) return auctionCmp;
  return String(a?.lot_number ?? '').localeCompare(
    String(b?.lot_number ?? ''),
    undefined,
    LOCALE_NUMERIC
  );
}

/** Non-mutating sort for bidder / scan lot arrays. */
export function sortLotsByAuctionThenLot(lots) {
  if (!lots || lots.length === 0) return [];
  return [...lots].sort(compareLotsByAuctionThenLot);
}

/** Sort bare lot-number strings for display (e.g. comma list in search). */
export function sortLotNumberStringsForDisplay(strings) {
  if (!strings || strings.length === 0) return [];
  return [...strings].sort((a, b) =>
    String(a).localeCompare(String(b), undefined, LOCALE_NUMERIC)
  );
}
